"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Animate sub menu flyouts.
 * @param {boolean} animationState should the animation fire?
 * @param {number} duration how long should the animation last?
 * @param {object} styles styles to apply to the component.
 * @param {boolean} isMobile is the component rendering on the mobile view?
 * @param {node} children the component's children to render.
 * @return A jsx menu component.
 */
const MenuAnimation = _ref => {
  let {
    animationState,
    duration,
    styles,
    isMobile,
    children
  } = _ref;
  function randomString(length) {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  const animationClass = animationState ? 'show' : 'dont-show';
  const uniqueId = randomString(5);
  if (isMobile) {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("style", {
      dangerouslySetInnerHTML: {
        __html: `
              .sub-menu-mobile-${uniqueId} {
                visibility: hidden;
                max-height: 0;
                opacity: 0;
              }

              @keyframes show-mobile {
                0% {
                  display: block;
                }
                100% {
                  max-height: 500px;
                  visibility: visible;
                  opacity: 1;
                }
              }

              .sub-menu-mobile-${uniqueId}.show {
                animation: show-mobile ${duration}ms 1 ease-in-out forwards;
              }
          `
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: `sub-menu-mobile-${uniqueId} ${animationClass}`,
      style: styles
    }, children));
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: `
          .sub-menu-desktop-${uniqueId} {
            visibility: hidden;
            width: 0;
            opacity: 0;
            left: 100%;
            overflow: hidden;
            white-space: nowrap;
          }
          @keyframes show-desktop {
            50% {
              width: 100%;
            }
            100% {
              width: 100%;
              visibility: visible;
              opacity: 1;
            }
          }
          .sub-menu-desktop-${uniqueId}.show {
            animation: show-desktop ${duration}ms linear forwards;
          }
        `
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: `sub-menu-desktop-${uniqueId} ${animationClass}  sub-menu-wrapper`,
    style: styles
  }, children));
};
MenuAnimation.propTypes = {
  animationState: _propTypes.default.bool,
  duration: _propTypes.default.number,
  mobileStyles: _propTypes.default.object,
  styles: _propTypes.default.object,
  isMobile: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = exports.default = MenuAnimation;